import { ReactionBarSelector } from '@charkour/react-reactions'
import { ButtonBase, ClickAwayListener, Fade } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import React, { useCallback, useState } from 'react'
import { trackEvent } from 'utils/analyticsUtils'
import ReactionsButtonIcon from './icons/ReactionsButtonIcon'
import { useDispatch, useSelector } from 'react-redux'
import Actions from 'actions'

const useStyles = makeStyles(theme => ({
  button: {
    display: 'flex',
    alignItems: 'center',
    height: 32,
    width: 32,
    borderRadius: 8,
    backgroundColor: 'white',
    cursor: 'pointer',
    position: 'absolute',
    bottom: -8,
    right: 10,
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)'
  },
  selector: {
    position: 'absolute',
    bottom: -50,
    right: 0,
    zIndex: 999
  },
  alignLeft: {
    right: 'auto',
    left: 10
  }
}))

const ReactionsButton = ({ isVisible, alignLeft, messageId }) => {
  const { reactionItems } = useSelector(state => state.appReducer.appconfig?.app)

  const Reactions = reactionItems.map(reaction => ({
    node: <div>{reaction}</div>,
    key: `${reaction}`
  }))

  const classes = useStyles()
  const dispatch = useDispatch()
  const grinUserId = useSelector(state => state.profileReducer.doctor?.user?.id)

  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const handleButtonClicked = useCallback(() => {
    trackEvent('Chat reactions - button clicked', {
      isMenuOpen: !isMenuOpen
    })
    setIsMenuOpen(!isMenuOpen)
  }, [isMenuOpen])

  const handleOnReactionSelected = useCallback(
    reaction => {
      dispatch(
        Actions.reactToMessage({
          messageId,
          reaction,
          grinUserId
        })
      )
    },
    [dispatch, grinUserId, messageId]
  )

  return (
    <ClickAwayListener onClickAway={() => setIsMenuOpen(false)}>
      <div>
        <Fade in={isVisible || isMenuOpen}>
          <ButtonBase
            className={`${classes.button} ${alignLeft ? classes.alignLeft : ''}`}
            onClick={handleButtonClicked}
          >
            <ReactionsButtonIcon />
            <div className={classes.selector}>
              {isMenuOpen && (
                <ReactionBarSelector reactions={Reactions} iconSize={24} onSelect={handleOnReactionSelected} />
              )}
            </div>
          </ButtonBase>
        </Fade>
      </div>
    </ClickAwayListener>
  )
}

export default ReactionsButton
